import { createContext, useContext, type ContextType, type FC, type ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    buyerHost: string;
    isMobile: boolean;
    isTablet?: boolean;
    isHeaderFullWidth?: boolean;
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    isAppDownloadCopyAbTestVariant?: boolean;
};

export const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
    buyerHost: '',
    isHeaderFullWidth: false,
    isUserTypeTrade: false,
    isUserTypeVip: false,
    isAppDownloadCopyAbTestVariant: false,
});

type HeaderFooterServerVars = ContextType<typeof HeaderFooterServerVarsContext>;

export function useHeaderFooterServerVars(): HeaderFooterServerVars {
    return useContext(HeaderFooterServerVarsContext);
}

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
    buyerHost: string;
    isHeaderFullWidth?: boolean;
    isUserTypeTrade?: boolean;
    isUserTypeVip?: boolean;
    isAppDownloadCopyAbTestVariant?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    buyerHost,
    isMobile,
    isTablet,
    isHeaderFullWidth,
    isUserTypeTrade,
    isUserTypeVip,
    isAppDownloadCopyAbTestVariant,
}) => (
    <HeaderFooterServerVarsContext
        value={{
            buyerHost,
            isMobile,
            isTablet,
            isHeaderFullWidth,
            isUserTypeTrade,
            isUserTypeVip,
            isAppDownloadCopyAbTestVariant,
        }}
    >
        {children}
    </HeaderFooterServerVarsContext>
);
